import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShipViewTableComponent } from './ship-view-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { CustomDatePickerModule } from "../../shared/components/custom-date-picker/custom-date-picker.module";
import { CustomInputModule } from "../../shared/components/custom-input/custom-input.module";
import { CustomDropdownModule } from "../../shared/components/custom-dropdown/custom-dropdown.module";
import { EndVoyageReportsModule } from "./pages/end-voyage-reports/end-voyage-reports.module";
import { MidVoyageReportsModule } from "./pages/mid-voyage-reports/mid-voyage-reports.module";
import { ShipViewRoutingRoutingModule } from './ship-view-routing-routing.module';



@NgModule({
    declarations: [
        ShipViewTableComponent
    ],
    exports: [
        ShipViewTableComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MaterialModule,
        MatPaginatorModule,
        MatSortModule,
        FormsModule,
        CustomDatePickerModule,
        CustomInputModule,
        CustomDropdownModule,
        EndVoyageReportsModule,
        MidVoyageReportsModule,
        ShipViewRoutingRoutingModule
    ]
})
export class ShipViewTableModule { }
